import React from 'react';
import styled from 'styled-components';
import { P2 } from '../Typography/Paragraphs';
import { COLOURS, MOBILE_ELEMS } from './Timeline._constants';
import { detectEnter } from './Timeline._helpers';
// @todo  fontSizes, rem !important
const Container = styled.div `
    margin-left: -1px;
    ${(props) => { var _a; return (((_a = props) === null || _a === void 0 ? void 0 : _a.isMobile) ? `` : `padding-left: 10px;`); }}
    line-height: 30px;
    position: relative;
    ${(props) => {
    var _a;
    return ((_a = props) === null || _a === void 0 ? void 0 : _a.isMobile) ? `
    cursor: grab;
    cursor: move;
    cursor: -moz-grab;
    cursor: -webkit-grab;
    `
        : `cursor: pointer;`;
}}

    &${MOBILE_ELEMS.HIGHLIGHT} {
        ${(props) => { var _a; return (((_a = props) === null || _a === void 0 ? void 0 : _a.isMobile) ? `` : `background-color: ${COLOURS.RED_10}`); }};
    }
    &${MOBILE_ELEMS.HIGHLIGHT}:after {
        ${(props) => {
    var _a;
    return ((_a = props) === null || _a === void 0 ? void 0 : _a.isMobile) ? ``
        : `
        left: 67px;
        z-index: 5;
        `;
}};
    }
    &:after {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        top: 50%;
        margin-top: -5px;
        width: 0;
        height: 0;
        border-top: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 6px solid transparent;
        border-left: 6px solid ${COLOURS.RED_10};
        ${(props) => {
    var _a;
    return ((_a = props) === null || _a === void 0 ? void 0 : _a.isMobile) ? `
        left: 50%;
        top: 140%;
        margin: -5px 0 0 -4px;
        border-bottom: 6px solid ${COLOURS.GREY_30};
        border-left: 6px solid transparent;
        ` : ``;
}}
    }
`;
const LinkMobile = styled(P2).attrs(() => ({
    tag: 'span',
})) `
  ${(props) => (props.fontSize ? `font-size: ${props.fontSize}px !important;` : '')}
  font-size: 14px !important;
  line-height: 16px;
  transition: font-size 0.3s ease;
`;
const LinkDesktop = styled(LinkMobile) `
  font-family: ${({ theme }) => theme.fontFamilyBold};
  font-size: 14px;
  line-height: 16px;
  margin-left: 7px;
  padding: 0 2px;
`;
const TimelineTimelineYearSingle = ({ className, handleClick, isMobile, year, id, tabIndex, ariaExpanded, }) => {
    const isHighlight = () => {
        return className === MOBILE_ELEMS.HIGHLIGHT || false;
    };
    const handleClickLocal = (evt, year, id) => {
        evt.preventDefault();
        evt.stopPropagation();
        handleClick(year, id);
    };
    const handleKeyboardLocal = (evt, year, id) => {
        if (detectEnter(evt)) {
            handleClickLocal(evt, year, id);
        }
    };
    return (React.createElement(Container, { className: className, isMobile: isMobile, "data-year": year, "data-id": id },
        isMobile && React.createElement(LinkMobile, { asWhite: isHighlight(), field: { value: year } }),
        !isMobile && (React.createElement(LinkDesktop, { asWhite: isHighlight(), field: { value: year }, onClick: (evt) => handleClickLocal(evt, year, id), onKeyDown: (evt) => handleKeyboardLocal(evt, year, id), tabIndex: tabIndex, "aria-expanded": ariaExpanded, role: "button" }))));
};
export default TimelineTimelineYearSingle;
